import React, { Component } from 'react';
import {
  Button,
  Form,
  FormGroup,
  Label,
  Row,
  Col,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import { toast } from 'react-toastify';
import jsonToCsv from '../../utils/jsonToCsv';
import { downloadOnlineSpecialistData } from '../../services/api/doc-on-call';

export default class DownloadOnlineDataModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: '',
      endDate: '',
      loading: false,
    };
  }

  onSubmit = () => {
    const { startDate, endDate } = this.state;
    if (!startDate || !endDate) {
      toast.error('Please select both start and end dates');
      return;
    }
    this.setState({ loading: true });

    const params = {
      startDate,
      endDate,
    };

    downloadOnlineSpecialistData(params)
      .then(() => {
        toast.info('Download initiated. Please check your email shortly.');
      })
      .catch((err) => {
        toast.error(err?.errorMessage || err?.message || 'Download failed');
      })
      .finally(() => {
        this.setState({ loading: false });
        if (this.props.closeModal) {
          this.props.closeModal();
        }
      });
  };

  render() {
    return (
      <>
        <Modal
          isOpen={this.props.modalIsOpen}
          toggle={() => this.props.closeModal()}
        >
          <ModalHeader
            className="bg-primary"
            toggle={() => this.props.closeModal()}
          >
            Download Online data
          </ModalHeader>
          <ModalBody>
            <Form>
              <FormGroup>
                <Row>
                  <Col className="col-3">
                    <Label for="startDate">Start Date</Label>
                  </Col>
                  <Col>
                    <Input
                      id="startDate"
                      type="date"
                      value={this.state.startDate}
                      onChange={(e) =>
                        this.setState({ startDate: e.target.value })
                      }
                    />
                  </Col>
                </Row>
              </FormGroup>
              <FormGroup>
                <Row>
                  <Col className="col-3">
                    <Label for="endDate">End Date</Label>
                  </Col>
                  <Col>
                    <Input
                      id="endDate"
                      type="date"
                      value={this.state.endDate}
                      onChange={(e) =>
                        this.setState({ endDate: e.target.value })
                      }
                    />
                  </Col>
                </Row>
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter>
            <div className="flex flex-row justify-end">
              <div className="flex flex-col m-3">
                <Button
                  color="primary"
                  onClick={this.onSubmit}
                  disabled={this.state.loading}
                >
                  {this.state.loading ? 'Downloading…' : 'Download'}
                </Button>
              </div>
              <div className="flex flex-col m-3">
                <Button
                  color="secondary"
                  onClick={this.props.closeModal}
                  disabled={this.state.loading}
                >
                  Close
                </Button>
              </div>
            </div>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}
